<template><section><template>
<h3>Animate</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-button @click.native="show=!show">fadeLeft</n3-button>
  <transition name="fadeLeft">
    <div v-if="show" class="content">
        <h4>Title</h4>
        <p>...</p>
        <p>...</p>
        <p>...</p>
    </div>
  </transition>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-comment">&lt;!--work width ( v-if , v-show , v-for)--&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span>  <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"show=!show"</span>&gt;</span>fadeLeft<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">transition</span> <span class="hljs-attr">name</span>=<span class="hljs-string">"fadeLeft"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-if</span>=<span class="hljs-string">"show"</span>  <span class="hljs-attr">class</span>=<span class="hljs-string">"content"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">h4</span>&gt;</span>Title<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">transition</span>&gt;</span>
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td>String</td>
<td>-</td>
<td><code>fade</code> <code>fadeLeft</code><code>fadeDown</code><code>bounce</code><code>scale</code></td>
</tr>
</tbody>
</table>
</div>
</template>


</section></template>
<style scoped>
  .content {
    box-shadow: 1px 1px 10px #ddd;
    padding:10px;
    margin-top: 10px;
  }
</style>
<script>
  export default {
    data () {
      return {
        show: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// n3AnimateDocs.md?6b43fcaa